export default {
    state: {
        headers: [
            { text: 'Name', align: 'center', sortable: false, value: 'name' },
        ],
        notes: {
        },
        records: [],
        editCourse:null,
    },
    getters: {


    },
    mutations: {
        setInteractions (state, data){
            state.notes.records = data;
        }
    },
    actions: {
        setInteractions ({commit}, data){
            commit('setInteractions', data)
        }
    }
}